import { render, staticRenderFns } from "./LogoVitis.vue?vue&type=template&id=4b9fc9b4&scoped=true"
import script from "./LogoVitis.vue?vue&type=script&lang=js"
export * from "./LogoVitis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9fc9b4",
  null
  
)

export default component.exports